import React from "react";

const EmergencyMessage = ({ heading, text }) => {
  return (
    <div className="row text-center">
      <div className="col-sm-12">
        <h2>{heading}</h2>
        <div
          className="m-0"
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        ></div>
      </div>
    </div>
  );
};

export default EmergencyMessage;
